<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="'提示框'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="500px"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData" labelWidth="150px">
        <section slot="chooseVehicle" slot-scope="prop" class>
          <ChooseVehicle
            style="display: inline-block"
            :isRadio="true"
            v-model="prop.form.chooseVehicle"
          />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  servicerSelectList,
} from 'api/service';
import {
  getEnumList,
} from 'api';
import ChooseVehicle from 'components/choose/vehicle';
import {mapState} from 'vuex';
import {addBankBalance, companyBankcardList} from 'api/getPay';
export default {
  components: {
    ChooseVehicle,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        acctNoOptions: [], // 账户名称
        form: [
          { // 账户名
            label: '账户名',
            value: 'acctNo',
            type: 'select',
            placeholder: '请选择账户名称',
            onChange: this.handleAccoutChange,
          },
          {
            label: '银行卡号',
            value: 'bankCardNo',
            type: 'show',
          },
          {
            label: '请填写该卡的余额',
            value: 'balance',
            type: 'input',

          },
        ],
        rules: {
          acctNo: [ // 请选择账户名称
            { required: true, message: '请选择账户名称', trigger: 'blur' },
          ],
          balance: [ // 请填写该卡的余额
            { required: true, message: '请填写该卡的余额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      this.originData = item;
      this.getFormSelectList();
    },

    async getFormSelectList () {
      const res = await companyBankcardList();// 账户名称
      this.formData.acctNoOptions = [];
      let priObj = {};
      if (res.allPriAcct.length > 0) {
        res.allPriAcct.map((item) => {
          if (item.balance === null && item.balanceDouble === null) {
            priObj = {
              label: item.acctName, // 账户名称
              value: item.acctNo, // 银行卡号s
              accountType: item.bankType, // 账户类型
              bankCardNo: item.acctNo,
              acctNo: item.acctName,
            };
            this.formData.acctNoOptions.push(priObj);
          }
        });
      }
      let pubObj = {};
      if (res.allPubAcct.length > 0) {
        res.allPubAcct.map((item) => {
          if (item.balance === null && item.balanceDouble === null) {
            pubObj = {
              label: item.acctName, // 账户名称
              value: item.acctNo, // 银行卡号s
              accountType: item.bankType, // 账户类型
              bankCardNo: item.acctNo,
              acctNo: item.acctName,
            };
            this.formData.acctNoOptions.push(pubObj);
          }
        });
      }
    },


    customFormPost () {
      this.$refs.customForm.sub();
    },

    handleAccoutChange () {
      const accout = this.$refs.customForm.getVal('acctNo');
      this.$refs.customForm.setVal('bankCardNo', accout);
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      let formData = null;
      if (form) {
        formData = {
          acctNo: form.acctNo,
          balance: form.balance,
        };
      }
      const res = await addBankBalance(formData);
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '设置初始余额成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
